
import { Link } from "react-router-dom";
import { Info, Mail } from "lucide-react";
import FooterSocialLinks from "./FooterSocialLinks";

const FooterInfoSocial = () => {
  // Function to handle newsletter link click
  const handleNewsletterClick = (e: React.MouseEvent) => {
    // Add a console log to help debug
    console.log("Newsletter link clicked");
    
    // If we're already on the homepage, we just need to update the hash
    if (window.location.pathname === '/') {
      // Just let the default behavior happen (update hash)
      return;
    }
    
    // If we're on another page, navigate to homepage with hash
    // Use an actual full URL to avoid issues with relative paths
    window.location.href = `/${window.location.pathname.includes('/') ? '' : ''}#newsletter`;
    e.preventDefault();
  };

  return (
    <div className="flex flex-col items-center md:items-start">
      <h3 className="text-lg font-semibold mb-4 text-white flex items-center justify-center md:justify-start">
        <Info className="h-5 w-5 text-blue-300 mr-2" />
        Info
      </h3>
      
      <div className="grid grid-cols-1 gap-2 mb-2">
        <Link 
          to="/meista" 
          className="text-blue-200 hover:text-white transition-colors flex items-center justify-center md:justify-start gap-1.5"
          aria-label="Tietoa Lainasampo.fi:stä"
          title="Tietoa meistä"
        >
          Tietoa meistä
        </Link>
        <Link 
          to="/tietosuojaseloste" 
          className="text-blue-200 hover:text-white transition-colors flex items-center justify-center md:justify-start gap-1.5"
          aria-label="Tietosuojaseloste"
          title="Tietosuojaseloste ja henkilötietojen käsittely"
        >
          Tietosuojaseloste
        </Link>
        <Link 
          to="/kayttoehdot" 
          className="text-blue-200 hover:text-white transition-colors flex items-center justify-center md:justify-start gap-1.5"
          aria-label="Käyttöehdot"
          title="Sivuston käyttöehdot"
        >
          Käyttöehdot
        </Link>
        <Link 
          to="/yhteystiedot" 
          className="text-blue-200 hover:text-white transition-colors flex items-center justify-center md:justify-start gap-1.5"
          aria-label="Ota yhteyttä"
          title="Ota yhteyttä meihin"
        >
          Ota yhteyttä
        </Link>
        <Link 
          to="/ukk" 
          className="text-blue-200 hover:text-white transition-colors flex items-center justify-center md:justify-start gap-1.5"
          aria-label="Usein kysytyt kysymykset"
          title="Vastauksia usein kysyttyihin kysymyksiin"
        >
          UKK
        </Link>
        <Link 
          to="/artikkelit" 
          className="text-blue-200 hover:text-white transition-colors flex items-center justify-center md:justify-start gap-1.5"
          aria-label="Lue artikkeleitamme"
          title="Hyödyllisiä artikkeleita aiheesta"
        >
          Artikkelit
        </Link>
        <Link 
          to="/#newsletter" 
          onClick={handleNewsletterClick}
          className="text-blue-200 hover:text-white transition-colors flex items-center justify-center md:justify-start gap-1.5 font-medium"
          aria-label="Liity postituslistallemme"
          title="Liity postituslistallemme ja saa vinkkejä"
        >
          <Mail className="h-4 w-4 text-blue-300 mr-1" />
          <span>Liity postituslistalle</span>
        </Link>
      </div>
      
      {/* Social links section */}
      <FooterSocialLinks />
    </div>
  );
};

export default FooterInfoSocial;
